











































































































































import {
  computed,
  defineComponent,
  reactive,
  ref,
  Ref,
  watch,
} from '@vue/composition-api';
import { useFormat } from 'vivat';
import { useQuery, useResult } from '@vue/apollo-composable';
import axios from 'axios';

import useAuth from '@/useAuth';

import getDashboardInformation from '@/gql/dashboard/getDashboardInformation.gql';

import TransportItem from '@/components/Overall/TransportItem.vue';
import DeliveryMap from '@/components/Overall/DeliveryMap.vue';
import CommonPanelWithExpandable from '@/components/CommonPanelWithExpandable.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';

const Shipping = defineComponent({
  components: {
    TransportItem,
    DeliveryMap,
    CommonPanelWithExpandable,
    ViewDeliveryMarkerModal,
  },
  setup() {
    const { me } = useAuth();
    const NOW = useFormat.date().computerShortDate();
    // const NOW = '2022-07-08';
    const rerender = ref(true);

    function displayDate(date: string) {
      return useFormat.date(date).displayFullThaiDate();
    }

    const filter = reactive({
      // DUMMY
      // range: {
      //   from: useFormat.date('2021-11-20').computerShortDate(),
      //   to: useFormat.date('2021-11-20').computerShortDate(),
      // },
      range: {
        from: NOW,
        to: NOW,
      },
      now: {
        from: NOW,
        to: NOW,
      },
    });

    const computedDateInput = computed(() => ({
      future: {
        from: useFormat.date(filter.range.from).dayjs.add(1, 'day').format('YYYY-MM-DD'),
        to: useFormat.date(filter.range.from).dayjs.add(7, 'day').format('YYYY-MM-DD'),
      },
      past: {
        from: useFormat.date(filter.range.from).dayjs.subtract(7, 'day').format('YYYY-MM-DD'),
        to: useFormat.date(filter.range.from).dayjs.subtract(1, 'day').format('YYYY-MM-DD'),
      },
      range: {
        from: `${filter.range.from} 00:00:00`,
        to: `${filter.range.to} 23:59:59`,
      },
      now: {
        from: `${filter.now.from} 00:00:00`,
        to: `${filter.now.to} 23:59:59`,
      },
    }));

    const dnStatusCounter = reactive({
      PREPARE_TO_DELIVER: 0,
      ON_THE_WAY: 0,
      SUCCESS: 0,
      UNSUCCESS: 0,
      HAS_CANCELED_ORDER: 0,
      todayCreatedDeliveries: 0,
      today: 0,
      deliveriesSuccess: 0,
      deliveriesUnsuccess: 0,
    });

    const computedAllStatus = computed(() => ([
      { name: 'ส่งสำเร็จ', data: dnStatusCounter.SUCCESS, color: 'green' },
      { name: 'ส่งไม่สำเร็จ', data: dnStatusCounter.UNSUCCESS, color: 'red' },
      { name: 'อยู่ระหว่างขนส่ง', data: dnStatusCounter.ON_THE_WAY, color: 'blue' },
      { name: 'เตรียมจัดส่ง', data: dnStatusCounter.PREPARE_TO_DELIVER, color: 'yellow' },
    ]));
    const deliveryNotes: Ref<any> = ref([]);
    const computedDeliveryNoteList = computed(() => deliveryNotes.value.map((item: any, index: number) => ({
      uniqueId: item.uniqueId,
      driver: item.driver.name,
      vehicle: item.vehicle.license,
      status: item.status,
    })));

    const { result: getDashboardInformationResult, loading: getDashboardInformationLoading, refetch: refetchDashboardInformation } = useQuery(getDashboardInformation, computed(() => ({
      filterDeliveryCreatedAtBetween: filter.range.from ? computedDateInput.value.range : undefined,
      filterDeliveryDateBetween: filter.range.from ? filter.range : undefined,
      // filterPastDeliveryDateBetween: filter.range.from ? computedDateInput.value.past : undefined,
      // filterFutureDeliveryDateBetween: filter.range.from ? computedDateInput.value.future : undefined,
      // filterDeliveryDate: filter.range.from ? filter.range.from : undefined,
      todayCount: computedDateInput.value.now.from ? computedDateInput.value.now : undefined,
      now: filter.now.from,
      filterHubId: me.hub?.id || undefined,
    })), () => ({
      fetchPolicy: 'network-only',
    }));

    const dashboardInformationResult = computed(() =>
      // eslint-disable-next-line
      getDashboardInformationResult?.value?.rangeCountDeliveryNote ||
      // eslint-disable-next-line
      [
        { status: 'PREPARE_TO_DELIVER', count: 0 },
        { status: 'ON_THE_WAY', count: 0 },
        { status: 'SUCCESS', count: 0 },
        { status: 'UNSUCCESS', count: 0 },
        { status: 'HAS_CANCELED_ORDER', count: 0 },
      ]);
    const zeroChartsInformation = computed(() => {
      for (let i = 0; i < dashboardInformationResult.value.length; i += 1) {
        if (dashboardInformationResult.value[i].count > 0) return false;
      }
      return true;
    });

    const successDeliveries = useResult(getDashboardInformationResult, 0, (data) => data.successDeliveries.paginatorInfo.total);
    const unsuccessDeliveries = useResult(getDashboardInformationResult, 0, (data) => data.unsuccessDeliveries.paginatorInfo.total);
    const todayCreatedDeliveries = useResult(getDashboardInformationResult, 0, (data) => data.todayCreatedDeliveries.paginatorInfo.total);
    const todayNewDeliveries = useResult(getDashboardInformationResult, 0, (data) => data.todayNewDeliveries.paginatorInfo.total);
    const deliveryNotesResult = useResult(getDashboardInformationResult, [], (data) => data.todayDeliveryNote.data);
    const totalWeight = computed(() => getDashboardInformationResult?.value?.aggregateDeliveries?.totalWeight || 0);
    // const computedPastDeliveryNoteList = computed(() => pastDeliveryNotes.value.map((item: any, index: number) => ({
    //   uniqueId: item.uniqueId,
    //   driver: item.driver.name,
    //   vehicle: item.vehicle.license,
    //   status: item.status,
    // })));
    // const computedFutureDeliveryNoteList = computed(() => futureDeliveryNotes.value.map((item: any, index: number) => ({
    //   uniqueId: item.uniqueId,
    //   driver: item.driver.name,
    //   vehicle: item.vehicle.license,
    //   status: item.status,
    // })));

    const mapMarkers: Ref<any[]> = ref([]);
    const cars: Ref<any[]> = ref([]);
    const dnIds: Ref<any[]> = ref([]);
    const dnColors: Ref<string[]> = ref([]);
    const computedDnColors = computed(() => dnColors.value);
    function mapDeliveryNotesResultToMarker(deliveryNotesFNValue: any) {
      mapMarkers.value = [];
      cars.value = [];
      dnIds.value = [];
      dnColors.value = [];
      deliveryNotesFNValue.forEach((dn: any, dnIndex: number) => {
        dnIds.value.push((dn as any).id);
        dnColors.value.push('');
        if (!(mapMarkers.value[dnIndex])) mapMarkers.value.push([]);

        const positionsLat: any[] = [];
        const positionsLong: any[] = [];
        mapMarkers.value[dnIndex] = dn.deliveries.filter((dv: any) => {
          const latIndex = positionsLat.indexOf(dv.computedLatLong.lat);
          const longIndex = positionsLong.indexOf(dv.computedLatLong.long);
          if ((latIndex !== -1 && (positionsLong.length > latIndex && positionsLong[latIndex] === dv.computedLatLong.long))
            || (longIndex !== -1 && (positionsLat.length > longIndex && positionsLat[longIndex] === dv.computedLatLong.lat))
          ) return undefined;
          positionsLat.push(dv.computedLatLong.lat);
          positionsLong.push(dv.computedLatLong.long);
          return dv;
        }).map((dv: any) => ({
          delivery: dv,
          lat: parseFloat(dv.lat) >= -90 && parseFloat(dv.lat) <= 90 ? parseFloat(dv.lat) : 0,
          lng: parseFloat(dv.long) >= -180 && parseFloat(dv.long) <= 180 ? parseFloat(dv.long) : 0,
        }));

        if (dn.locations.length > 0) {
          cars.value.push({
            car: dn.vehicle,
            lastPosition: {
              lat: parseFloat(dn.locations[0].lat) >= -90 && parseFloat(dn.locations[0].lat) <= 90 ? parseFloat(dn.locations[0].lat) : 0,
              lng: parseFloat(dn.locations[0].long) >= -180 && parseFloat(dn.locations[0].long) <= 180 ? parseFloat(dn.locations[0].long) : 0,
            },
          });
        }
      });
    }

    watch(() => getDashboardInformationResult.value, (newVal, oldVal) => {
      if (!getDashboardInformationLoading.value) {
        deliveryNotes.value = newVal?.todayDeliveryNote?.data || [];
        mapDeliveryNotesResultToMarker(deliveryNotes.value);
        dnStatusCounter.today = todayNewDeliveries.value as any;
        dnStatusCounter.todayCreatedDeliveries = todayCreatedDeliveries.value as any;
        dnStatusCounter.deliveriesSuccess = successDeliveries.value as any;
        dnStatusCounter.deliveriesUnsuccess = unsuccessDeliveries.value as any;
        dnStatusCounter.PREPARE_TO_DELIVER = newVal?.rangeCountDeliveryNote.find((countObj: any) => countObj.status === 'PREPARE_TO_DELIVER')?.count || 0;
        dnStatusCounter.ON_THE_WAY = newVal?.rangeCountDeliveryNote.find((countObj: any) => countObj.status === 'ON_THE_WAY')?.count || 0;
        dnStatusCounter.SUCCESS = newVal?.rangeCountDeliveryNote.find((countObj: any) => countObj.status === 'SUCCESS')?.count || 0;
        dnStatusCounter.UNSUCCESS = newVal?.rangeCountDeliveryNote.find((countObj: any) => countObj.status === 'UNSUCCESS')?.count || 0;
        dnStatusCounter.HAS_CANCELED_ORDER = newVal?.rangeCountDeliveryNote.find((countObj: any) => countObj.status === 'HAS_CANCELED_ORDER')?.count || 0;
      }
    });

    const viewMapModal = ref(null);
    const mapMarkersForModal: Ref<{ delivery: any; lat: number; lng: number; open: boolean }[]> = ref([]);
    const vehicleTraverse: Ref<{ car: any; stamps: { lat: number; lng: number }[] }> = ref({
      car: {
        id: -1,
        license: '',
        lastPosition: { lat: 0, lng: 0 },
      },
      stamps: [],
    });
    const computedCars = computed(() => (vehicleTraverse.value.car.id > -1 ? [vehicleTraverse.value.car] : []));
    function pendingToViewMap(deliveryNote: any) {
      const positionsLat: any[] = [];
      const positionsLong: any[] = [];

      mapMarkersForModal.value = deliveryNote.deliveries.filter((dv: any) => {
        const latIndex = positionsLat.indexOf(dv.computedLatLong.lat);
        const longIndex = positionsLong.indexOf(dv.computedLatLong.long);
        if ((latIndex !== -1 && (positionsLong.length > latIndex && positionsLong[latIndex] === dv.computedLatLong.long))
          || (longIndex !== -1 && (positionsLat.length > longIndex && positionsLat[longIndex] === dv.computedLatLong.lat))
        ) return undefined;
        positionsLat.push(dv.computedLatLong.lat);
        positionsLong.push(dv.computedLatLong.long);
        return dv;
      }).map((dv: any) => ({
        delivery: dv,
        open: false,
        lat: parseFloat(dv.lat) >= -90 && parseFloat(dv.lat) <= 90 ? parseFloat(dv.lat) : 0,
        lng: parseFloat(dv.long) >= -180 && parseFloat(dv.long) <= 180 ? parseFloat(dv.long) : 0,
      }));
      if (deliveryNote.locations.length > 0) {
        const [lastPos] = deliveryNote.locations;
        vehicleTraverse.value.car = { id: deliveryNote.vehicle.id, license: deliveryNote.vehicle.license, lastPosition: { lat: lastPos.lat, lng: lastPos.long } };
        vehicleTraverse.value.stamps = deliveryNote.locations.map((location: any) => ({
          lat: parseFloat(location.lat) >= -90 && parseFloat(location.lat) <= 90 ? parseFloat(location.lat) : 0,
          lng: parseFloat(location.long) >= -180 && parseFloat(location.long) <= 180 ? parseFloat(location.long) : 0,
        }));
        vehicleTraverse.value.stamps.splice(0, 1);
      } else {
        vehicleTraverse.value.car = { id: -1 };
        vehicleTraverse.value.stamps = [];
      }
      (viewMapModal.value as any).open();
    }

    async function sendMessageToAndroid() {
      await axios.post('https://fcm.googleapis.com/fcm/send', {
        to: '/topics/tracking',
        priority: 'high',
        data: {
          Name: 'Get Tracking',
        },
      }, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'key=AAAASVn0KfU:APA91bGBnuzZ-lhoyGlOAytMBFX_6ZTtVwJ6xzb6CpDtRZcxZkc42o-BoUejxQzZNHEX7IPxZFmnxk_tVQYW7d6gW0Ijdw-fS-eVXcTqeFeCzhMK15Idjr1S9daHeJgEo3LpEhKkCatj',
        },
      });
    }

    async function pendingToReloadMap() {
      await sendMessageToAndroid();
      const reloadTimeout = setTimeout(async () => {
        refetchDashboardInformation();
      }, 10000);
    }

    function renderColorDeliveryNote(payload: any) {
      const index = dnIds.value.findIndex((itm: any) => itm === payload.id);
      if (index > -1) {
        rerender.value = false;
        dnColors.value[index] = payload.color;
        rerender.value = true;
      }
    }

    return {
      NOW,
      filter,
      displayDate,
      rerender,

      computedAllStatus,
      dnStatusCounter,
      zeroChartsInformation,
      deliveryNotes,
      computedDeliveryNoteList,
      totalWeight,

      cars,
      dnIds,
      computedDnColors,

      mapMarkers,

      mapMarkersForModal,
      viewMapModal,
      vehicleTraverse,
      computedCars,
      pendingToViewMap,

      pendingToReloadMap,

      renderColorDeliveryNote,
    };
  },
});

export default Shipping;
